const FieldGroupCollection = require('./FieldGroupCollection');
const { getAllFieldGroupsFromOrder } = require('./fieldFunctions');

/**
 * Returns a FieldGroupCollection which contains all the FieldGroups from an order.
 *
 * @param {Cart|Order} cartOrOrder
 *
 * @return {FieldGroupCollection}
 */
const createFieldGroupCollectionFromOrder = (cartOrOrder) => {
    let collection = new FieldGroupCollection();

    collection.addFieldGroups(getAllFieldGroupsFromOrder(cartOrOrder));

    return collection;
};

module.exports = {
    createFieldGroupCollectionFromOrder,
};
